export default {"src":"/_next/static/media/color-correction.8396e473.svg","height":36,"width":37};